import { render, staticRenderFns } from "./TodoComment.vue?vue&type=template&id=447aab28&"
import script from "./TodoComment.vue?vue&type=script&lang=js&"
export * from "./TodoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports